import React, { useContext } from "react";
import Layout from "layouts/LayoutMasterDetail";

import { StoreContext } from "shared/context/store-context";
import { discountTypes } from "shared/util/types";

import DiscountItem from "./DiscountItem";

const DiscountsList = () => {
  const itemType = "discount";
  const listName = "main_discounts";

  const { discounts, InsertDiscount, UpdateDiscount, DeleteDiscount } = useContext(StoreContext);

  const pageItems = discounts;

  const listColumns = [
    { field: "name", headerName: "İndirim Adı", width: 300 },
    {
      field: "type",
      headerName: "İndirim Türü",
      width: 200,
      valueGetter: (params) => discountTypes.find((item) => item.value.toString() === params.row.type.toString()).label,
    },
    { field: "amount", headerName: "İndirim Miktarı", width: 200 },
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={DiscountItem}
      NewItemComponent={DiscountItem}
      DeleteItem={DeleteDiscount}
      InsertItem={InsertDiscount}
      UpdateItem={UpdateDiscount}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default DiscountsList;
